export enum ClaimStatusEnum {
	New = 1,
	Sent = 2,
	Voided = 3,
	Rejected = 4,
	PendingSending = 5,
	Removed = 7,
  InProgress = 8,
}
